import React from 'react';

// Clickable <th> that toggles asc/desc on a sort key and shows a direction arrow (▲/▼) when
// active, or a neutral ⇅ otherwise. Pair with the sortRows() helper in utils/sortRows.js.
// Originally local to pages/trends/SalesTrendsPage.js; promoted here once a second page needed
// the identical pattern rather than re-duplicating it.
export default function SortableHeader({ label, title, sortKey, sort, onSort, className = '' }) {
  const active = sort.key === sortKey;
  return (
    <th
      className={className}
      style={{ cursor: 'pointer', userSelect: 'none' }}
      onClick={() => onSort(sortKey)}
    >
      {title ? <span title={title} style={{ cursor: 'help' }}>{label}</span> : label}
      <span style={{ marginLeft: 4, color: active ? '#1b2638' : '#ced4da', fontSize: 10 }}>
        {active ? (sort.dir === 'asc' ? '▲' : '▼') : '⇅'}
      </span>
    </th>
  );
}
